export const defaultFilterOptions =
  (valueKey: string, labelKey: string) => (options: any[], searchString: string, selectedOptions: any[]) =>
    options
      .filter((item) => {
        if (Array.isArray(selectedOptions)) {
          return !selectedOptions.find((selectedOption) => selectedOption[valueKey] === item[valueKey]);
        }
        return selectedOptions !== item;
      })
      .filter((item) => (item[labelKey] || '').toLowerCase().includes(searchString.toLowerCase()));

export const filterArrayValue = (value: any[], options: any[], valueKey = 'value') =>
  value
    .map((item) => {
      if (typeof item === 'number') {
        return options.find((option) => option[valueKey] === item);
      }
      return item;
    })
    .filter((item) => !!item);
